import {BLOG_PATH, TEST_PRODUCT_TYPES, SITE_DOMAIN_CURRENT_BASE} from './const';

const navigation = {
  blogHomePage: {
    getPath() {
      return BLOG_PATH;
    },
    getCanonicalPath() {
      return BLOG_PATH;
    },
    getCanonicalUrl() {
      return `${SITE_DOMAIN_CURRENT_BASE}${this.getCanonicalPath()}`;
    },
  },
  blogCategory: {
    getPath(handle: string) {
      return `${BLOG_PATH}/cat/${handle}`;
    },
    getCanonicalPath(handle: string) {
      return `${BLOG_PATH}/cat/${handle}`;
    },
    getCanonicalUrl(handle: string) {
      return `${SITE_DOMAIN_CURRENT_BASE}${this.getCanonicalPath(handle)}`;
    },
  },
  blogDetail: {
    getPath(handle: string) {
      return `${BLOG_PATH}/${handle}`;
    },
    getCanonicalPath(handle: string) {
      return `${BLOG_PATH}/${handle}`;
    },
    getCanonicalUrl(handle: string) {
      return `${SITE_DOMAIN_CURRENT_BASE}${this.getCanonicalPath(handle)}`;
    },
  },
  productDetail: {
    getPath(handle: string) {
      return `/products/${handle}`;
    },
    getCanonicalPath(handle: string) {
      return `/products/${handle}`;
    },
    getCanonicalUrl(handle: string) {
      return `${SITE_DOMAIN_CURRENT_BASE}${this.getCanonicalPath(handle)}`;
    },
  },
  collectionDetail: {
    getPath(handle: string) {
      return `/collections/${handle}`;
    },
    getCanonicalPath(handle: string) {
      return `/collections/${handle}`;
    },
    getCanonicalUrl(handle: string) {
      return `${SITE_DOMAIN_CURRENT_BASE}${this.getCanonicalPath(handle)}`;
    },
  },
  activityDetail: {
    getPath(handle: string) {
      return `/activities/${handle}`;
    },
    getCanonicalPath(handle: string) {
      return `/activities/${handle}`;
    },
    getCanonicalUrl(handle: string) {
      return `${SITE_DOMAIN_CURRENT_BASE}${this.getCanonicalPath(handle)}`;
    },
  },
  pageCustom: {
    getPath(handle: string) {
      return `/${handle}`;
    },
    getCanonicalPath(handle: string) {
      return `/${handle}`;
    },
    getCanonicalUrl(handle: string) {
      return `${SITE_DOMAIN_CURRENT_BASE}${this.getCanonicalPath(handle)}`;
    },
  },
  homePage: {
    getPath() {
      return '/';
    },
    getCanonicalPath() {
      return `/`;
    },
    getCanonicalUrl() {
      return SITE_DOMAIN_CURRENT_BASE;
    },
  },
  skiTestHomePage: {
    getPath(type: string, year: number | string) {
      if (type === TEST_PRODUCT_TYPES.NORDIC_SKI) {
        return `/${year}-nordic-ski-test`;
      } else if (type === TEST_PRODUCT_TYPES.SNOWBOARD) {
        return `/${year}-snowboard-test`;
      }
      return `/${year}-ski-test`;
    },
    getCanonicalPath(type: string, year: number | string) {
      return this.getPath(type, year);
    },
    getCanonicalUrl(type: string, year: number | string) {
      return `${SITE_DOMAIN_CURRENT_BASE}${this.getCanonicalPath(type, year)}`;
    },
  },

  skiTestCategoryPage: {
    getPath(type: string, year: number | string, handle: string) {
      if (type === TEST_PRODUCT_TYPES.NORDIC_SKI) {
        return `/nordic-ski-tests/${year}/category/${handle}`;
      } else if (type === TEST_PRODUCT_TYPES.SNOWBOARD) {
        return `/snowboard-tests/${year}/category/${handle}`;
      }
      return `/ski-tests/${year}/category/${handle}`;
    },
    getCanonicalPath(type: string, year: number | string, handle: string) {
      if (handle == 'tester') {
        if (type === TEST_PRODUCT_TYPES.NORDIC_SKI) {
          return `/${year}-nordic-ski-test/${handle}`;
        } else if (type === TEST_PRODUCT_TYPES.SNOWBOARD) {
          return `/${year}-snowboard-test/${handle}`;
        }
        return `/${year}-ski-test/${handle}`;
      } else {
        if (type === TEST_PRODUCT_TYPES.NORDIC_SKI) {
          return `/${year}-nordic-ski-test/category/${handle}`;
        } else if (type === TEST_PRODUCT_TYPES.SNOWBOARD) {
          return `/${year}-snowboard-test/category/${handle}`;
        }
      }
      return `/${year}-ski-test/category/${handle}`;
    },
    getCanonicalUrl(type: string, year: number | string, handle: string) {
      return `${SITE_DOMAIN_CURRENT_BASE}${this.getCanonicalPath(
        type,
        year,
        handle,
      )}`;
    },
  },
  skiTestDetail: {
    getPathLegacy(type: string, year: number | string, handle: string) {
      if (type === TEST_PRODUCT_TYPES.NORDIC_SKI) {
        return `/${year}-nordic-ski-test/skis/${handle}`;
      } else if (type === TEST_PRODUCT_TYPES.SNOWBOARD) {
        return `/${year}-snowboard-test/skis/${handle}`;
      }
      return `/${year}-ski-test/skis/${handle}`;
    },
    getPath(type: string, year: number | string, handle: string) {
      if (type === TEST_PRODUCT_TYPES.NORDIC_SKI) {
        return `/nordic-ski-tests/${year}/${handle}`;
      } else if (type === TEST_PRODUCT_TYPES.SNOWBOARD) {
        return `/snowboard-tests/${year}/${handle}`;
      }
      return `/ski-tests/${year}/${handle}`;
    },
    getCanonicalPath(type: string, year: number | string, handle: string) {
      if (isNaN(Number(year))) {
        year = handle.split('-')[0];
      }
      if (type === TEST_PRODUCT_TYPES.NORDIC_SKI) {
        return `/${year}-nordic-ski-test/${handle}`;
      } else if (type === TEST_PRODUCT_TYPES.SNOWBOARD) {
        return `/${year}-snowboard-test/snowboards/${handle}`;
      }
      return `/${year}-ski-test/skis/${handle}`;
    },
    getCanonicalUrl(type: string, year: number | string, handle: string) {
      return `${SITE_DOMAIN_CURRENT_BASE}${this.getCanonicalPath(
        type,
        year,
        handle,
      )}`;
    },
  },

  skiTesterDetail: {
    getPathLegacy(type: string, year: number | string, handle: string) {
      if (type === TEST_PRODUCT_TYPES.NORDIC_SKI) {
        return `/${year}-nordic-ski-test/tester/${handle}`;
      } else if (type === TEST_PRODUCT_TYPES.SNOWBOARD) {
        return `/${year}-snowboard-test/tester/${handle}`;
      }
      return `/${year}-ski-test/tester/${handle}`;
    },
    getPath(type: string, year: number | string, handle: string) {
      if (type === TEST_PRODUCT_TYPES.NORDIC_SKI) {
        return `/nordic-ski-tests/${year}/tester/${handle}`;
      } else if (type === TEST_PRODUCT_TYPES.SNOWBOARD) {
        return `/snowboard-tests/${year}/tester/${handle}`;
      }
      return `/ski-tests/${year}/tester/${handle}`;
    },
    getCanonicalPath(type: string, year: number | string, handle: string) {
      if (type === TEST_PRODUCT_TYPES.NORDIC_SKI) {
        return `/${year}-nordic-ski-test/tester/${handle}`;
      } else if (type === TEST_PRODUCT_TYPES.SNOWBOARD) {
        return `/${year}-snowboard-test/tester/${handle}`;
      }
      return `/${year}-ski-test/tester/${handle}`;
    },
    getCanonicalUrl(type: string, year: number | string, handle: string) {
      return `${SITE_DOMAIN_CURRENT_BASE}${this.getCanonicalPath(
        type,
        year,
        handle,
      )}`;
    },
  },
  login: {
    getPath(redirect?: string) {
      const query = redirect != null ? `?redirect=${redirect}` : '';
      return `/account/login${query}`;
    },
  },
  loyaltyPanel: {
    getPath() {
      return `/account/loyalty`;
    },
  },
};

export default navigation;
